import navContent from '@content/nav.yaml'
import type { NavContent } from '@/types/content'

const content = navContent as unknown as NavContent

export function Nav() {
  return (
    <nav>
      <a href="#" className="nav-wordmark">{content.wordmark}<span className="dot">.</span></a>
      <ul className="nav-links">
        {content.links.map(link => (
          <li key={link.href}><a href={link.href}>{link.label}</a></li>
        ))}
      </ul>
      <div className="nav-right">
        <button className="btn-ng" onClick={() => document.getElementById('book')?.scrollIntoView({behavior:'smooth'})}>{content.buttons.ghost.label}</button>
        <button className="btn-np" onClick={() => document.getElementById('book')?.scrollIntoView({behavior:'smooth'})}>{content.buttons.primary.label}</button>
      </div>
    </nav>
  )
}
